<template>
  <div class="gathering__steps">
    <div
      class="gathering__step"
      :class="{active: isActive >= 1 && isActive <= 2}"
    >
      <h6>Insamling</h6>

      <img class="gathering__step-image" src="../../../assets/svg/checklist-duotone.svg"/>

      <p>Vi samlar in uppgifter från aktörer och myndighetersamt du anger vissa.</p>
    </div>

    <img src="../../../assets/svg/long-arrow-right.svg">

    <div class="gathering__step" :class="{active: isActive === 3}">
      <h6>Analysering</h6>

      <img class="gathering__step-image" src="../../../assets/svg/microscope-duotone.svg"/>

      <p>Vi analyserar informationen och verifierar den.</p>
    </div>

    <img src="../../../assets/svg/long-arrow-right.svg">

    <div class="gathering__step" :class="{active: isActive === 6}">
      <h6>Nulägesanalys</h6>

      <img class="gathering__step-image" src="../../../assets/svg/tachometer-duotone.svg"/>

      <p>Kontinuerlig information som förbättrar din pension.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GatheringStepCounter',
  props: [ 'step' ],
  computed: {
    isActive: function () {
      return this.step;
    }
  },
}
</script>

<style lang="scss" scoped>
.gathering {
  &__steps {
    display: grid;
    grid-template-columns: 1fr auto 1fr auto 1fr;
    grid-gap: 2rem;
    align-items: center;
    margin: 2rem 0;
    overflow-x: auto;
  }

  &__step {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $light;
    padding: 2rem;
    border-radius: $borderRadius;
    min-width: 256px;

    &-image {
      margin: 1.5rem 0;
    }

    &.active {
      border: 4px solid $mediumGreen;
    }
  }
}
</style>